export const myButtonStyles = (theme, variant, customVariant) => {
  if (customVariant === 'pagination') {
    return {
      minWidth: '32px',
      height: '32px',
      borderRadius: '6px',
      padding: 0,
      border: '1px solid',
      borderColor: theme.palette.grey[300],
      bgcolor: theme.palette.background.paper,
      color: theme.palette.text.primary,
      fontWeight: 500,
      transition: 'all 0.2s ease',
      '&:hover': {
        bgcolor: theme.palette.grey[100],
        transform: 'none',
        boxShadow: 'none',
      },
    };
  }

  if (customVariant === 'paginationActive') {
    return {
      minWidth: '32px',
      height: '32px',
      borderRadius: '6px',
      padding: 0,
      border: '1px solid',
      borderColor: theme.palette.primary.main,
      bgcolor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      fontWeight: 500,
      transition: 'all 0.2s ease',
      '&:hover': {
        bgcolor: theme.palette.primary.dark,
        transform: 'none',
        boxShadow: 'none',
      },
    };
  }

  return {
    borderRadius: '8px',
    textTransform: 'none',
    fontWeight: 600,
    padding: '10px 20px',
    transition: 'all 0.3s ease',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: theme.shadows[8],
    },
    ...(variant === 'contained' && {
      background: `linear-gradient(45deg, ${theme.palette.primary.main} 30%, ${theme.palette.primary.light} 90%)`,
      '&:hover': {
        background: `linear-gradient(45deg, ${theme.palette.primary.dark} 30%, ${theme.palette.primary.main} 90%)`,
      },
    }),
  };
};
